import BemIt, { addClass } from "@gtechdoodler/bem-it";
import { BoxBaseProps } from "./BoxBase.types";
import { StyledBoxBase } from "./BoxBase.styles";
import { ColorPaletteOptions } from "../../../../types/theming";
import ScrollableContainer from "./ScrollableContainer";
import React from "react";

/**
 * This is a 'base' component and should not be exported. Presently, for internal use only.
 */
const BoxBase = React.forwardRef<HTMLElement>(
	(
		{
			className,
			children,
			overflow,
			overflowX,
			overflowY,
			...props
		}: BoxBaseProps<ColorPaletteOptions>,
		ref
	) => {
		const block = new BemIt("BoxBase");

		const isScrollable =
			[overflow, overflowX, overflowY].findIndex(
				(value) => value === "auto" || value === "scroll"
			) > -1;

		if (isScrollable) {
			return (
				<ScrollableContainer
					ref={ref}
					className={addClass(className).after(block)}
					overflow={overflow}
					overflowX={overflowX}
					overflowY={overflowY}
					{...props}
				>
					{children}
				</ScrollableContainer>
			);
		} else {
			return (
				<StyledBoxBase
					ref={ref}
					className={addClass(className).after(block)}
					overflow={overflow}
					overflowX={overflowX}
					overflowY={overflowY}
					{...props}
				>
					{children}
				</StyledBoxBase>
			);
		}
	}
);

export default BoxBase;
